import React, { useEffect, useState } from 'react'
import { useLocation } from '@reach/router'

import {
  countryCodeName,
  currentDate,
  defaultFieldNames,
  devValues,
  isMaster,
  isProd,
  isQA,
  masterValues,
  prodValues,
  projectCodeName,
  PropertyCode,
  qaValues,
  recordTypeOptions,
} from '../InquireNowForm.utils'

const HiddenFields = ({
  propertyName,
}: {
  propertyName: string | undefined
}) => {
  const location = useLocation()
  const [fieldNames, setFieldNames] = useState(defaultFieldNames)

  const [returnUrl, setReturnUrl] = useState(
    `${process.env.GATSBY_SITE_URL}/${location.pathname}`,
  )

  const [currentProperty, setCurrentProperty] = useState<string | undefined>('')

  const [currentRecordType, setCurrentRecordType] = useState<
    string | undefined
  >('')

  useEffect(() => {
    if (isProd) {
      setFieldNames(prodValues)
    } else if (isQA) {
      setFieldNames(qaValues)
    } else if (isMaster) {
      setFieldNames(masterValues)
      setReturnUrl(`${process.env.GATSBY_SITE_URL}${location.pathname}`)
    } else {
      setFieldNames(devValues)
      setReturnUrl(`${process.env.GATSBY_SITE_URL}${location.pathname}`)
    }

    const targetEnv = isProd
      ? 'prod'
      : isQA
        ? 'qa'
        : isMaster
          ? 'master'
          : 'dev'

    const filteredRecordTypes = recordTypeOptions.find(
      (recordType) => recordType.env === targetEnv,
    )

    setCurrentRecordType(filteredRecordTypes?.value)
  }, [])

  useEffect(() => {
    if (propertyName) {
      const curr = PropertyCode.find(
        (property) => property.label === propertyName,
      )

      setCurrentProperty(curr?.label)
    }
  }, [propertyName])

  return (
    <>
      <input
        type="hidden"
        id="lead_source"
        name="lead_source"
        value="Web Form"
      />

      <input
        type="hidden"
        name="captcha_settings"
        value={`{"keyname":"Avida","fallback":"true","orgId":"${
          fieldNames?.orgId
        }","ts":"${currentDate}"}`}
      />

      <input type="hidden" name="oid" value={fieldNames?.oid} />

      <input type="hidden" name="retURL" value={returnUrl} />

      {/*
       Debugging issues will be sent to this email
        SET to 0 - for deployment
        SET to 1 - for debugging
      */}
      <input type="hidden" name="debug" value="0" />

      <input type="hidden" name="debugEmail" value="sung.park@salesforce.com" />

      <input
        type="hidden"
        id={fieldNames?.brand}
        name={fieldNames?.brand}
        title="Brand"
        value="Avida"
      />

      <input
        type="hidden"
        id={fieldNames?.campaignCode}
        name={fieldNames?.campaignCode}
        maxLength={255}
        size={20}
        value=""
      />

      <input
        type="hidden"
        id={fieldNames?.preferredSeller}
        name={fieldNames?.preferredSeller}
        maxLength={100}
        size={20}
        value=""
      />

      <input
        type="hidden"
        id={fieldNames?.digitalLead}
        name={fieldNames?.digitalLead}
        value="1"
      />

      <input
        type="hidden"
        id={fieldNames?.otherThanAlisi}
        name={fieldNames?.otherThanAlisi}
        value="0"
      />

      {/* Project Name */}
      <input
        type="hidden"
        id={projectCodeName}
        name={projectCodeName}
        value={currentProperty}
      />

      {/* Record Type - Default to "Individual" other option is "Corporate" */}
      <input
        type="hidden"
        id="recordType"
        name="recordType"
        value={currentRecordType}
      />

      {/* Mobile Number Country Code */}
      <input
        type="hidden"
        id={countryCodeName}
        name={countryCodeName}
        value="PH"
      />

      {/* Description  */}
      <input type="hidden" id="description" name="description" value="" />
    </>
  )
}

export default HiddenFields
